
<template>
  <div>
    <h1 class="page-title">Prototype du produit</h1>
    <FormKit
      v-model="selectedPrototype"
      type="radio"
      @change="getProductPrototype()"
      :options="{
        '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f': 'E-billet',
        '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f': 'Produit physique',
        '6a3fe435-fdfd-11ed-a0b1-de1c3c38600f': 'Carte cadeau',
        '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f': 'Redirection sur site partenaire / Codes promo',
        '6a401dea-fdfd-11ed-a0b1-de1c3c38600f': 'Carte de membre'
      }"
      help="Selectionner un prototype de produit"
      validation="required"
      name="prototype"
      
    />
  </div>
 
</template>


<script  lang="ts">
  import { useProductStore } from '@/stores/product/prototypeStore';
  import { ref, watch } from 'vue';

    export const selectedPrototype = ref('6a3f537e-fdfd-11ed-a0b1-de1c3c38600f')
    export const getProductPrototype = () => {
      
        const currentProductPrototype = selectedPrototype.value;
        const productStore = useProductStore();
        productStore.setCurrentProductPrototype(currentProductPrototype);
    };

    export default {
      props: {
      productUuid: String 
      
    },
  }
  
</script>

<script setup lang="ts">

  watch(selectedPrototype, () => {
    getProductPrototype();
  });
  

</script>


